var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgContextMenuIcon = function SvgContextMenuIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.943 8.33203C14.043 8.33203 14.943 7.43203 14.943 6.33203C14.943 5.23203 14.043 4.33203 12.943 4.33203C11.843 4.33203 10.943 5.23203 10.943 6.33203C10.943 7.43203 11.843 8.33203 12.943 8.33203ZM12.943 10.332C11.843 10.332 10.943 11.232 10.943 12.332C10.943 13.432 11.843 14.332 12.943 14.332C14.043 14.332 14.943 13.432 14.943 12.332C14.943 11.232 14.043 10.332 12.943 10.332ZM12.943 16.332C11.843 16.332 10.943 17.232 10.943 18.332C10.943 19.432 11.843 20.332 12.943 20.332C14.043 20.332 14.943 19.432 14.943 18.332C14.943 17.232 14.043 16.332 12.943 16.332Z",
    fill: "var(--iconColor, currentColor)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.942993 0.332031)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgContextMenuIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "context-menu-icon.86b01c4c9376092ef409337ac39b885b.svg";